import React from "react";
import AdminNavbar from "./AdminLayout/AdminNavbar";
import AdminFooter from "./AdminLayout/AdminFooter";
import AdminSidebar from "./AdminLayout/AdminSidebar";
import { API_URL } from "../../../src/Constant.js";

const AdminDashboard = () => {
  return (
    <>
      <AdminNavbar />
      <div>
        <center>
          <br />
          <h1>Admin Dashboard</h1>
          <br />
        </center>
      </div>
      <AdminFooter />
    </>
  );
};

export default AdminDashboard;
